/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './patient-identifier.reducer';

export const PatientIdentifierDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const patientIdentifierEntity = useAppSelector(state => state.patientIdentifier.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="patientIdentifierDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.patientIdentifier.detail.title">PatientIdentifier</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.patientIdentifier.id">Id</Translate>
            </span>
          </dt>
          <dd>{patientIdentifierEntity.id}</dd>
          <dt>
            <span id="identifier">
              <Translate contentKey="tinyMedicRestApp.patientIdentifier.identifier">Identifier</Translate>
            </span>
          </dt>
          <dd>{patientIdentifierEntity.identifier}</dd>
          <dt>
            <span id="provider">
              <Translate contentKey="tinyMedicRestApp.patientIdentifier.provider">Provider</Translate>
            </span>
          </dt>
          <dd>{patientIdentifierEntity.provider}</dd>
          <dt>
            <span id="preferred">
              <Translate contentKey="tinyMedicRestApp.patientIdentifier.preferred">Preferred</Translate>
            </span>
          </dt>
          <dd>{patientIdentifierEntity.preferred ? 'true' : 'false'}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.patientIdentifier.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{patientIdentifierEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.patientIdentifier.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{patientIdentifierEntity.timestampentry}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.patientIdentifier.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{patientIdentifierEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.patientIdentifier.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{patientIdentifierEntity.cursor}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.patientIdentifier.active">Active</Translate>
            </span>
          </dt>
          <dd>{patientIdentifierEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="verified">
              <Translate contentKey="tinyMedicRestApp.patientIdentifier.verified">Verified</Translate>
            </span>
          </dt>
          <dd>{patientIdentifierEntity.verified ? 'true' : 'false'}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientIdentifier.patient">Patient</Translate>
          </dt>
          <dd>{patientIdentifierEntity.patient ? patientIdentifierEntity.patient.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientIdentifier.identifierType">Identifier Type</Translate>
          </dt>
          <dd>{patientIdentifierEntity.identifierType ? patientIdentifierEntity.identifierType.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/patient-identifier" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/patient-identifier/${patientIdentifierEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PatientIdentifierDetail;
